 
import React from 'react';
import { PassedResult, AttributeName } from '../../../../common/style';
import Tick from './tick';

interface Props {
    name: string;
}

const Passed: React.FC<Props> = ({ name }) => (
    <span>
        <AttributeName>{name}</AttributeName>
        <PassedResult>
            Pass <Tick />
        </PassedResult>
    </span>
);

export default Passed;
